import { useEffect, useRef } from "react";
import { observer } from "mobx-react";

import { isGdprRegion } from "@formant/core/common/isGdprRegion";

import { intercomAppKey } from "../config";
import { useStores } from "../context/StoreContext";

export const IntercomInjector = observer(function IntercomInjector() {
    const { organizationStore, userStore } = useStores();
    const organization = organizationStore.authenticated();
    const user = userStore.authenticated();
    const intercomDisabled = false;

    const initialized = useRef<boolean>(false);
    useEffect(() => {
        if (initialized.current) {
            // already initialized
            return;
        }

        if (!intercomAppKey) {
            // intercom not configured
            return;
        }

        if (intercomDisabled) {
            return;
        }

        if (!user || !organization) {
            // user and org haven't yet loaded
            return;
        }

        // initialization should only happen once
        initialized.current = true;

        const intercomUser = isGdprRegion(user.region)
            ? { user_id: user.id, organization_id: user.organizationId }
            : {
                  email: user.email,
                  name: `${user.firstName} ${user.lastName}`,
              };

        window.Intercom("boot", {
            app_id: intercomAppKey,
            ...intercomUser,
            hide_default_launcher: true,
            company: {
                company_id: organization.id,
                name: organization.name,
                plan: organization.plan,
                website: organization.website,
                industry: organization.industry,
            },
        });
    }, [intercomAppKey, user, organization, intercomDisabled]);

    return null;
});
